export const isRestrictedSlug = (slugs) => {
    const url = new URL(document.location.href).pathname;
    const slug = url.split("/").pop();
    if (!slugs?.length || !slug)
        return false;
    return slugs.some((restrictedSlug) => slug.includes(restrictedSlug));
};
//# sourceMappingURL=isRestrictedSlug.js.map